import React, { useState, useEffect } from 'react'
import { footerBg, footerBgDark } from '../../assets/svg'
import { useStateContext } from '../../context/ContextProvider'
import { footerData } from '../../constants'
import {Link} from "react-router-dom"
function Footer() {
    const { currentMode, currentLang } = useStateContext()
    const bgImage = currentMode === 'Dark' ? footerBgDark : footerBg;
    const Ar = currentLang === "ar"
    const [flip, setFlip] = useState(false)

    useEffect(() => {
        if (!Ar) {
            setFlip(true)
        } else {
            setFlip(false)
        }
    }, [Ar])

    return (
        <section  
            className={`relative flex w-full lg:h-[593px] bg-no-repeat bg-cover bg-center mt-12 transition-transform duration-500 ${flip ? 'transform scale-x-[-1]' : ''}`}
            style={{ backgroundImage: `url(${bgImage})` }}
  
        >
            <div className={`container mx-auto px-4 lg:px-8 mt-72 md:mt-64 lg:mt-56 mb-10 lg:mb-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 transition-transform duration-500 ${flip ? 'transform scale-x-[-1]' : ''}`}>
                
                {/** Column 1 - Logo and Social */}
                <div className="flex flex-col  items-center lg:items-start gap-4">
                    <img 
                        src={footerData.colom1.image} 
                        alt="Manafith Logo" 
                        className='w-48 h-auto object-contain' 
                    />
                    <h6 className={`text-light-subtitle h6 dark:text-dark-subtitle text-center ${Ar ?"lg:text-right" :"lg:text-left"}lg:text-right`}>
                        {Ar ? footerData.colom1.title_Ar : footerData.colom1.title_En}
                    </h6>
                    <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                        {footerData.colom1.social.map((social) => (
                            <div key={social.id}>
                                <a 
                                    href={social.path} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-light-subtitle dark:text-dark-subtitle hover:text-light-blue dark:hover:text-dark-blue transition-colors duration-300 text-2xl"
                                >
                                    {social.icon}
                                </a>
                            </div>
                        ))}
                    </div>
                </div>

                {/** Column 2 - Links */}
                <div className="flex flex-col items-center    lg:items-start">
                    <h6 className="text-light-subtitle  border-b-2 border-light-link dark:border-dark-link  h6 dark:text-dark-subtitle pb-2 mb-4  text-center ">
                        {Ar ? footerData.colom2.title_Ar : footerData.colom2.title_En}
                    </h6>
                    <div className="flex flex-col items-center lg:items-start gap-3 w-full">
                        {footerData.colom2.links.map((link) => (
                            <Link 
                                key={link.id} 
                                to={`/Privacy_policy_page/${link.id}`}
                                className={`text-light-subtitle body-2  cursor-pointer dark:text-dark-subtitle hover:text-light-blue dark:hover:text-dark-blue transition-colors duration-300 w-full text-center ${Ar ? "lg:text-right": "lg:text-left"}`}
                            >
                                {Ar ? link.title_Ar : link.title_En}
                            </Link>
                        ))}
                    </div>
                </div>

                {/** Column 3 - Additional Links */}
                <div className="flex flex-col items-center lg:items-start">
                <h6 className="text-light-subtitle border-b-2 border-light-link dark:border-dark-link h6 dark:text-dark-subtitle pb-2 mb-4   text-center ">
                        {Ar ? footerData.colom3.title_Ar : footerData.colom3.title_En}
                    </h6>
                    <div className="flex flex-col items-center lg:items-start gap-3 w-full">
                        {footerData.colom3.links.map((link) => (
                            <Link 
                                key={link.id} 
                                to={`/Terms_and_Conditions/${link.id}`}
                                className={`text-light-subtitle body-2 dark:text-dark-subtitle hover:text-light-blue dark:hover:text-dark-blue transition-colors duration-300 w-full text-center ${Ar ? "lg:text-right": "lg:text-left"}`}
                                >
                                {Ar ? link.title_Ar : link.title_En}
                            </Link>
                        ))}
                    </div>
                </div>

                {/** Column 4 - Contact Info */}
                <div className="flex flex-col items-center lg:items-start">
                <h6 className="text-light-subtitle h6  border-b-2 border-light-link dark:border-dark-link  dark:text-dark-subtitle pb-2  text-center mb-4">
                        {Ar ? footerData.colom4.title_Ar : footerData.colom4.title_En}
                    </h6>
                    <div className="flex flex-col gap-4 w-full">
                        {footerData.colom4.contacts.map((contact) => (
                            <div 
                                key={contact.index} 
                                className="flex items-center justify-center lg:justify-start gap-3 w-full"
                            >
                                <span className="text-light-link dark:text-dark-link">
                                    {contact.icon}
                                </span>
                                <span className="text-light-subtitle body-2 dark:text-dark-subtitle text-center lg:text-right">
                                    {Ar ? contact.text_Ar : contact.text_En}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer